import { CanvasHeights } from '@/components/Editor/types/editor';

export const getCanvasZoomToDefault = (canvasHeight: number): number => {
  return canvasHeight / CanvasHeights.default;
};
